import { t, Trans } from '@lingui/macro'
import { Button, Grid, TextField, Typography } from '@material-ui/core'
import { Launch } from '@material-ui/icons'
import { css } from 'emotion'
import React from 'react'
import { IAccount } from 'shopify-payment-core'

import { CopyToClipboard } from '../atoms/CopyToClipboard'
import { i18n } from '../i18n'

interface IProps {
  account: IAccount
}

const noop = () => {
  /* */
}

const clipboardIcon = css`
  font-size: 2rem;
  position: relative;
  left: 0.5rem;
  top: 0.5rem;
`

export const GatewaySetup: React.FC<IProps> = ({ account }) => {
  return (
    <>
      <Typography variant="body2">
        <Trans>
          Následující údaje vyplňte v{' '}
          <Button
            href={`https://${account.shopName}.myshopify.com/admin/settings/payments`}
            target="_blank"
          >
            nastavení platebních metod
            <Launch />
          </Button>
          .
        </Trans>
      </Typography>
      <br />
      <Grid container>
        <Grid item lg={11}>
          <TextField
            label={i18n._(t`Account name`)}
            value={account.accountName}
            onChange={noop}
            fullWidth
          />
        </Grid>
        <Grid item>
          <CopyToClipboard
            text={account.accountName}
            className={clipboardIcon}
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item lg={11}>
          <TextField
            label={i18n._(t`Account secret`)}
            value={account.accountSecret}
            onChange={noop}
            fullWidth
            multiline
          />
        </Grid>
        <Grid item lg={1}>
          <CopyToClipboard
            text={account.accountSecret}
            className={clipboardIcon}
          />
        </Grid>
      </Grid>
    </>
  )
}
